import { render } from "./CreditReturns.vue?vue&type=template&id=2acd95bb&scoped=true"
import script from "./CreditReturns.vue?vue&type=script&lang=js"
export * from "./CreditReturns.vue?vue&type=script&lang=js"

import "./CreditReturns.vue?vue&type=style&index=0&id=2acd95bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acd95bb"]])

export default __exports__